function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  fill: "white",
  stroke: "#55BB91"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.5001 17.0849L22.4151 14.9999L21.7051 15.7049L24.5001 18.4999L30.5001 12.4999L29.7951 11.7949L24.5001 17.0849Z",
  fill: "#55BB91"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.1335 25.6667L17.0668 19.6C17.6668 18.0667 17.3335 16.2667 16.0668 15C14.7335 13.6667 12.7335 13.4 11.1335 14.1334L14.0001 17L12.0001 19L9.06679 16.1334C8.26679 17.7334 8.60012 19.7334 9.93346 21.0667C11.2001 22.3334 13.0001 22.6667 14.5335 22.0667L20.6001 28.1334C20.8668 28.4 21.2668 28.4 21.5335 28.1334L23.0668 26.6C23.4001 26.3334 23.4001 25.8667 23.1335 25.6667Z",
  fill: "#55BB91"
});

var SvgWrenchPlus = function SvgWrenchPlus(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/wrench-plus.fc81672f.svg";
export { SvgWrenchPlus as ReactComponent };